import React, { useEffect } from "react";
import { Box, Grid, Tooltip, Stack, Chip, Button, IconButton, Typography, useTheme, Divider, TextField, Switch } from "@mui/material";
import Dropzone from "react-dropzone";
import { useQuery } from "@tanstack/react-query";
//Hooks
import { readOcr, postOcr } from "../../../hooks/images";
//Controls

//Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { tokens } from "../../../assets/theme";
import { useState } from "react";

// import messages from "./components/messages";
// import { FormattedMessage } from "react-intl";

const Ocr = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [attachment, setAttachment] = useState([]);
    const [ocrData, setOcrData] = useState("");
    const formData = (attachment) => {
        console.log("formdata in:", attachment);
        const formData = new FormData();

        //formData.append("taskId", props.taskId);
        formData.append("fileName", attachment.fileName);
        formData.append("fileType", attachment.fileType);
        formData.append("file", attachment.file);

        console.log("formdata returns:", formData.values[0]);

        return formData;
    }


    // const ocrQuery = useQuery(
    //     ["ocr"],
    //     () => readOcr(),
    //     {}
    // );

    // if (ocrQuery.isLoading) {
    //     return <Box>Loading...</Box>;
    // }

    const onDropCallback = (acceptedFiles) => {
        setAttachment(null);
        console.log("onDropCallback acceptedFiles:", acceptedFiles);
        //console.log("onDropCallback file", file);

        if (acceptedFiles === undefined) {
            console.log("onDropCallback acceptedFiles is undefined");
            return;
        }

        let file = acceptedFiles[0]; 
        if (file === undefined) {
            file = acceptedFiles; 
            console.log("onDropCallback acceptedFiles[0] is undefined");
        }

        console.log("onDropCallback file", file);

        const newAttachement = {
            fileName: file.name,
            fileType: file.type,
            //filePath: file.name,
            file: file,
            thumbnail: URL.createObjectURL(file), // Generate thumbnail as a data URL
        };

        const attachments = {
            file: file,
        };

        console.log("onDropCallback mediafiles", newAttachement);

        setAttachment(newAttachement);
        setOcrData("Processing...");

        postOcr(formData(newAttachement)).then((result) => {
            //attachmentsQuery.refetch();
            console.log("Result: ", result);
            //setAttachment({});
            setOcrData(result);

            //setOpenPopup(false);
            //data.refetch();
            //setShowBackdrop(false);
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            //pushErrorMessage(`Could not save Attachment.`);
        })
    };


    // console.log("Data: ", ocrQuery.data);



    function get14NumberStartingWith10(text) {
        if (text === undefined || text === null || text === "") {
            return;
        }
        if (text === "Processing...") {
            return text;
        }
        if (text.toString().length < 14) {
            return "No ordernumber found(" + text.toString() + ")";
        }

        const regex = /10\d{12}/g;
        try {
            const found = text.toString().match(regex);
            //setAttachment(null);
            props.handlePhotoSearch(found.toString());
            //props.handlePhotoSearch(found);

            return found;
        } catch (error) {
            console.log("Error: ", error);
            return " ???";
        }
    }

    function sendImage(){
        postOcr(formData(attachment)).then((result) => {
            //attachmentsQuery.refetch();
            console.log("Result: ", result);
            //setAttachment({});
            setOcrData(result);

            //setOpenPopup(false);
            //data.refetch();
            //setShowBackdrop(false);
        }).catch((error) => {
            console.log(error);
            //setShowBackdrop(false);
            //pushErrorMessage(`Could not save Attachment.`);
        })
    }




    console.log("OCR Data: ", ocrData);

    return (
        <>

            {/* {get14NumberStartingWith10(ocrQuery.data)} */}
            {/* {ocrData} */}


            <Box>
                <Box onClick={() => sendImage(attachment)}>Send</Box>
                <Box width="100px" height="100px">
                    <Dropzone onDrop={onDropCallback}
                        name="heroImage" multiple={false}>
                        {({ getRootProps, getInputProps }) => (
                            <div height="100%"
                                {...getRootProps()}
                                style={{
                                    border: "1px dashed #ccc",
                                    borderColor: "#799c4a",
                                    padding: "3px",
                                    margin: "3px",
                                    //marginLeft: "2px",
                                    // height: "100%",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    display: "flex",
                                    // flexDirection: "column",
                                    height: "95%",
                                    width: "95%"

                                }}
                            >
                                <input {...getInputProps()} />
                                {/* <Typography
                                display="flex"
                                sx={{ textAlign: "center", top: "auto" }}
                                justifyContent={"center"}
                            > */}

                                {attachment.thumbnail ? (
                                    <img
                                        src={attachment.thumbnail}
                                        alt={`Thumbnail`}
                                        style={{ maxWidth: "100%", maxHeight: "100%" }}

                                    />
                                ) :
                                    (
                                        <Box><Typography variant="h1">+</Typography></Box>
                                    )}
                                {/* </Typography> */}
                            </div>

                        )}
                    </Dropzone>
                </Box>
                <Divider color={colors.primary[900]} />
                {get14NumberStartingWith10(ocrData)}
                
                <Divider color={colors.primary[900]} />
                
                {ocrData}
                <Divider color={colors.primary[900]} />

            </Box>


        </>
    )
};

export default Ocr;


